import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { configureStore, combineReducers } from '@reduxjs/toolkit';
import uiReducer from './uiSlice';
import userReducer from './userSlice';
import casesReducer from './casesSlice';
import formsReducer from './formsSlice';
import quotesReducer from './quotesSlice';

const rootReducer = combineReducers({
	ui: uiReducer,
	user: userReducer,
	cases: casesReducer,
	forms: formsReducer,
	quotes: quotesReducer
});
export const store = configureStore({
	reducer: rootReducer,
	devTools: process.env.NODE_ENV !== 'production'
});

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;